<h2>{{ title }}</h2>


@if (loading) {
  <div class='spinner-container'>
    <mat-spinner></mat-spinner>
  </div>
}
@if (errorMessage) {
  <div class='errorMessage'>
    {{errorMessage}}
    <br>
    </div>
  }


  @if (message) {
    <strong>{{message}}
      <br>
        <br>
        </strong>
      }

      @if (headerMessage) {
        <mat-card>
          {{headerMessage}}
        </mat-card>
      }

      <br>